module.exports = __webpack_public_path__ + "static/media/poster_2.556e3cc1.png";